import { Box, Button, Stack, Text, Title } from "@mantine/core";
import EmailRounded from "@mui/icons-material/EmailRounded";
import Link from "next/link";
import { CSSProperties } from "react";
import PaymentVerificationBanner from "../../../public/static/images/permissions/paymentverificationbanner.svg";
import { useAccessBannerStyles } from "./NoAccess";

export default function PaymentError() {
  const { classes } = useAccessBannerStyles();
  return (
    <Stack className={classes.wrapper}>
      <Title
        order={2}
        className={classes.title}
        style={
          {
            "--banner-title-gradient":
              "linear-gradient(180deg, var(--mantine-color-incorrect-4) 0%, var(--mantine-color-incorrect-6) 100%)",
          } as CSSProperties
        }
      >
        Payment Failed!
      </Title>
      <Box className={classes.imgWrapper} mx={"auto"}>
        <PaymentVerificationBanner />
      </Box>
      <Text className={classes.text}>
        You have{" "}
        <span className={`${classes.highlight} ${classes.highlight3}`}>
          a failed payment
        </span>{" "}
        for your subscription.
      </Text>

      <Text className={classes.text}>
        Please{" "}
        <span className={`${classes.highlight} ${classes.highlight2}`}>
          head to your profile page and check your payment information
        </span>{" "}
        to ensure your payment can be processed.
      </Text>
      <Text className={classes.text}>
        If we do not receive a payment, your account{" "}
        <span className={`${classes.highlight} ${classes.highlight3}`}>
          will be deactivated within within 24h
        </span>
        !
      </Text>
      <Button
        className={classes.button}
        component={Link}
        href={"/profile/membership"}
        color={"incorrect"}
        size="md"
        leftSection={<EmailRounded />}
        mb={"xl"}
      >
        Re-attempt payment
      </Button>
      <Text className={classes.text}>
        If you are having problems contact us via email using the form at the
        bottom of our site.
      </Text>
    </Stack>
  );
}
